var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { ref: "wkSignaturePad", staticClass: "wk-signature-pad" },
    [
      _vm.disabled
        ? _c("wk-signature-image", {
            attrs: { src: _vm.value.url, height: _vm.height },
          })
        : [
            _c("vue-signature-pad", {
              key: _vm.height,
              ref: "signaturePad",
              attrs: {
                options: _vm.options,
                height: _vm.height,
                width: "100%",
              },
            }),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "wk-signature-pad__handle" },
              [
                _c(
                  "el-button",
                  {
                    attrs: { type: "text", icon: "wk wk-icon-reply" },
                    on: {
                      click: function ($event) {
                        return _vm.handleClick("undo")
                      },
                    },
                  },
                  [_vm._v("撤回")]
                ),
                _vm._v(" "),
                _c(
                  "el-button",
                  {
                    attrs: { type: "text", icon: "wk wk-icon-bin" },
                    on: {
                      click: function ($event) {
                        return _vm.handleClick("clear")
                      },
                    },
                  },
                  [_vm._v("清空")]
                ),
              ],
              1
            ),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }